import ClickableHelpText from '../HelpText/ClickableHelpText';
/**
 * `RadioSelection` is a small layout helper for grouped radio options.
 *
 * Behaviour:
 * - Renders nothing when `show` is false.
 * - Displays a label (`selectionName`) with optional `ClickableHelpText`.
 * - Renders `children` (expected to be radio input JSX elements).
 * - Renders an error message beneath the options when `error` is provided.
 */

type RadioSelectionProps = {
  show: boolean;
  selectionName: string;
  error?: string;
  fontDisabledClass: string;
  children: JSX.Element[];
  helpText?: string;
};

const RadioSelection = ({
  show,
  selectionName,
  error,
  fontDisabledClass,
  children,
  helpText
}: RadioSelectionProps): JSX.Element => {
  if (!show) return <></>;

  return (
    <>
      <div
        className={`control-label m05-bottom ${fontDisabledClass} help-text`}>
        {selectionName}
        {helpText && <ClickableHelpText helpText={helpText} />}
      </div>
      <div className='control'>
        {children}
        {error && <div className='error-style'>{error}</div>}
      </div>
    </>
  );
};

export default RadioSelection;
